/**
 * ToastContainer
 *
 * Renders all active notifications from PlatformContext as a stacked
 * column of toast cards in the bottom-right corner of the viewport.
 * Auto-removal is handled by PlatformContext's useEffect.
 *
 * Layout mirrors Themis (Story 3.AB) — single fixed wrapper, items
 * stack with gap, newest appears at the bottom and slides in from
 * the right. The producer side (`services/notificationBus.notify()`)
 * is unchanged; this is a pure visual refresh.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import ToastNotification from './ui/ToastNotification';
import { usePlatform } from '../contexts/PlatformContext';
import styles from './ui/ToastNotification/ToastNotification.module.css';

export default function ToastContainer() {
  const { notifications } = usePlatform();

  if (!notifications || notifications.length === 0) {
    return null;
  }

  return ReactDOM.createPortal(
    <div
      className={styles.container}
      role="region"
      aria-live="polite"
      aria-label="Notifications"
    >
      {notifications.map((n) => (
        <ToastNotification key={n.id} toast={n} />
      ))}
    </div>,
    document.body,
  );
}
